<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Pending Document list</h2>
          </div>
          <div class="body pt-0">
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              responsive
              ref="customerTable"
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(document)="data">
                <a
                  :href="require(`@/assets/model1.jpg`)"
                  target="_blank"
                  download
                >
                  {{ data.value }}
                </a>
              </template>
              <template #cell(customername)="data">
                <a
                  href="javascript:void(0);"
                  class="font-color"
                  :id="`tooltip${data.index}`"
                  @click="customerDetailModel(data.item)"
                >
                  {{ data.value }}
                </a>
                <b-tooltip
                  :target="`tooltip${data.index}`"
                  placement="right"
                  custom-class="customer-tooltip"
                >
                  <h6 class="p-2 border-bottom text-left">Customer Details</h6>
                  <div class="tooltip-body p-2 text-left">
                    <div class="d-flex">
                      <div class="pb-2 label">DOB:</div>
                      <div class="pb-2 value">
                        {{ data.item?.dob ? data.item?.dob : "-" }}
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="pb-2 label">Gender:</div>
                      <div class="pb-2 value">{{ data.item?.gender }}</div>
                    </div>
                    <div class="d-flex">
                      <div class="pb-2 label">Referred By:</div>
                      <div class="pb-2 value">
                        {{ data.item.referredby ? data.item.referredby : "-" }}
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="pb-2 label">No of Cards:</div>
                      <div class="pb-2 value">-</div>
                    </div>
                    <div class="d-flex">
                      <div class="pb-2 label">No of Receivers:</div>
                      <div class="pb-2 value">-</div>
                    </div>
                  </div>
                </b-tooltip>
              </template>
              <template #cell(status)="data">
                <span :class="`badge badge-${data.item.badge}`">
                  {{ data.value }}
                </span>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  size="sm"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item>Verify</b-dropdown-item>
                  <!-- <b-dropdown-item></b-dropdown-item> -->
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerDetailsModel :customerDetail="customerDetail" />
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { mapState, mapGetters } from "vuex";
import { GET_CUSTOMER_DETAILS } from "../../../store/actions.type.js";
import CustomerDetailsModel from "../../core/CustomerDetailsModel.vue";
export default {
  name: "PendingDocumentReview",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
    CustomerDetailsModel,
  },
  methods: {
    customerDetailModel(item) {
      this.$store.dispatch(GET_CUSTOMER_DETAILS, item.id).then((response) => {
        if (response.status == 200) {
          const customerdetails = response.data;
          this.$bvModal.show("customer-details");
          this.customerDetail = customerdetails;
        }
      });
    },
  },
  data() {
    return {
      customerDetail: null,
      items: [
        {
          document: "Passport",
          customername: "Mark",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          status: "pending",
          badge: "warning",
          mobileNumber: "16102347489",
        },
        {
          document: "Driving License",
          customername: "Tony Stark",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          status: "Uploded",
          badge: "success",
          mobileNumber: "16102347557",
        },
        {
          document: "Selfie verification",
          customername: "Alize Thomas",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          status: "failed",
          badge: "danger",
          mobileNumber: "14844493850",
        },
        {
          document: "Proof of Address",
          customername: "Tom Hardy",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          status: "pending",
          badge: "warning",
          mobileNumber: "15852135931",
        },
      ],

      fields: [
        {
          key: "document",
          label: "Document",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "customername",
          label: "Customer Name",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "mobileNumber",
          label: "Mobile Number",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          thClass: "th_sortfix",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      // newMemberUrl: window.location.origin+'/members-form/members-form.html',

      transactions_toprows: [
        {
          icon: "fa fa-user-plus",
          text: "New Customers(today)",
          price: "220",
        },
        {
          icon: "fa fa-calendar",
          text: "New This Month",
          price: "100",
        },
        {
          icon: "fa-users",
          text: "Total Customers",
          price: "3200",
        },
        {
          icon: "fa fa-users",
          text: "Valid Customers",
          price: "3000",
        },
      ],

      isVisibleFilter: false,

      search: {
        from: "",
        to: "",
        fname: "",
        mname: "",
        lname: "",
        rgroup: null,
        rstatus: null,
        country: null,
        keywords: "",
      },
    };
  },
  mounted() {
    this.totalRows = this.items.length;
  },
  computed: {
    ...mapGetters(["isLoading", "countryList"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
